import React, { createContext, useContext } from "react";
import styled from "styled-components";

import { DiscoveryProfile } from "../types";

import ProfileDetails, { ProfileDetailsBreakpoints } from "./ProfileDetails";
import ProfileIdentity, { ProfileIdentityBreakpoints } from "./ProfileIdentity";

interface ProfileDisplayBreakpoints {
  details: ProfileDetailsBreakpoints;
  identity: ProfileIdentityBreakpoints;
}

const ProfileDisplayContext = createContext<ProfileDisplayBreakpoints | null>(
  null
);

export const ProfileDisplayLayout: React.FC<{
  breakpoints: ProfileDisplayBreakpoints;
}> = ({ breakpoints, children }) => (
  <ProfileDisplayContext.Provider value={breakpoints}>
    <Layout $stackedLayoutBreakpoint={breakpoints.details.stackedLayout}>
      {children}
    </Layout>
  </ProfileDisplayContext.Provider>
);

export const ProfileDisplayDetails: React.FC<{
  profile: DiscoveryProfile;
  isOwnProfile?: boolean;
}> = ({ profile, isOwnProfile = false, children }) => {
  const breakpoints = useContext(ProfileDisplayContext);
  if (!breakpoints) {
    throw new Error(
      "ProfileDisplayDetails must be nested in ProfileDisplayLayout"
    );
  }
  return (
    <DetailsColumn>
      {children}
      <ProfileDetails
        profile={profile}
        title={profile.name || "Hacker profile"}
        breakpoints={breakpoints.details}
        isOwnProfile={isOwnProfile}
      />
    </DetailsColumn>
  );
};

export const ProfileDisplayIdentity: React.FC<{
  profile: DiscoveryProfile;
  connectSlack?: boolean;
  linkSlackAccount?: boolean;
}> = ({ profile, connectSlack, linkSlackAccount }) => {
  const breakpoints = useContext(ProfileDisplayContext);
  if (!breakpoints) {
    throw new Error(
      "ProfileDisplayIdentity must be nested in ProfileDisplayLayout"
    );
  }

  return (
    <ProfileIdentity
      profile={profile}
      title={profile.name || "Hacker profile"}
      breakpoints={breakpoints.identity}
      connectSlack={connectSlack}
      linkSlackAccount={linkSlackAccount}
    />
  );
};
const DetailsColumn = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 16px;
`;

const Layout = styled.div<{ $stackedLayoutBreakpoint: number }>`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 395px);
  gap: 48px;

  @media (max-width: ${({ $stackedLayoutBreakpoint }) =>
      $stackedLayoutBreakpoint}px) {
    display: flex;
    flex-direction: column-reverse;
    gap: 16px;
  }
`;
